import { RelatedDocumentLine, TransportInformations } from '~/types/document-builder';
import { DatiDDT, DatiTrasporto, RiferimentoDocumento } from '~/types/invoicing';
import { formatDateForAPI } from '~/utils/formatDate';

export function serializeRelatedDocument(document: RelatedDocumentLine): RiferimentoDocumento {
  return {
    codiceCig: document.CIGCode,
    codiceCommessaConvenzione: document.orderCode,
    codiceCup: document.CUPCode,
    data: document.date ? formatDateForAPI(document.date) : null,
    idDocumento: document.documentNumber,
    numItem: null,
    riferimentoNumeroLinea: null,
  };
}

export function serializeRelatedDocumentForDatiDdt(document: RelatedDocumentLine): DatiDDT {
  return {
    dataDdt: document.date ? formatDateForAPI(document.date) : formatDateForAPI(new Date()),
    numeroDdt: document.documentNumber,
    riferimentoNumeroLinea: null,
  };
}

export function serializeTransportInformations(document: TransportInformations): DatiTrasporto {
  return {
    indirizzoResa: {
      indirizzo: document.destination.address,
      cap: document.destination.postalCode,
      comune: document.destination.city,
      nazione: document.destination.country,
    },
    causaleTrasporto: document.transportReason,
    datiAnagraficiVettore: {
      idFiscaleIva: {
        idPaese: 'IT',
        idCodice: '00000000000',
      },
      anagrafica: {
        nome: document.courier,
      },
    },
    numeroColli: document.packsNumber,
    pesoNetto: document.weight,
  };
}
